var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white p-4",staticStyle:{"position":"relative"}},[_c('div',{staticClass:"inner-pag active"},[_c('QuestionSetAnswering',{attrs:{"goBack":_vm.goBack}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }